import { render, staticRenderFns } from "./MyAccount.vue?vue&type=template&id=4bf45ec8&scoped=true"
import script from "./MyAccount.vue?vue&type=script&lang=ts"
export * from "./MyAccount.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf45ec8",
  null
  
)

export default component.exports